import { render, staticRenderFns } from "./detail-area.vue?vue&type=template&id=461b698e&scoped=true"
import script from "./detail-area.vue?vue&type=script&lang=js"
export * from "./detail-area.vue?vue&type=script&lang=js"
import style0 from "./detail-area.vue?vue&type=style&index=0&id=461b698e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461b698e",
  null
  
)

export default component.exports